"use client";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollArea.module.css
var ScrollArea_module_default = {
	"root": "m_d57069b5",
	"content": "m_b1336c6",
	"viewport": "m_c0783ff9",
	"viewportInner": "m_f8f631dd",
	"scrollbar": "m_c44ba933",
	"thumb": "m_d8b5e363",
	"corner": "m_21657268"
};
//#endregion
export { ScrollArea_module_default as default };

//# sourceMappingURL=ScrollArea.module.mjs.map